// source: pbtypes/gen/flir_boson_driver/roi_settings.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.flir_boson_driver.RoiSettings', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flir_boson_driver.RoiSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flir_boson_driver.RoiSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flir_boson_driver.RoiSettings.displayName = 'proto.flir_boson_driver.RoiSettings';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flir_boson_driver.RoiSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.flir_boson_driver.RoiSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flir_boson_driver.RoiSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flir_boson_driver.RoiSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
startX: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
stopX: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
startY: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
stopY: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flir_boson_driver.RoiSettings}
 */
proto.flir_boson_driver.RoiSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flir_boson_driver.RoiSettings;
  return proto.flir_boson_driver.RoiSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flir_boson_driver.RoiSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flir_boson_driver.RoiSettings}
 */
proto.flir_boson_driver.RoiSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setStartX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setStopX(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setStartY(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setStopY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flir_boson_driver.RoiSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flir_boson_driver.RoiSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flir_boson_driver.RoiSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flir_boson_driver.RoiSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartX();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getStopX();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getStartY();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getStopY();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * optional float start_x = 1;
 * @return {number}
 */
proto.flir_boson_driver.RoiSettings.prototype.getStartX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flir_boson_driver.RoiSettings} returns this
 */
proto.flir_boson_driver.RoiSettings.prototype.setStartX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float stop_x = 2;
 * @return {number}
 */
proto.flir_boson_driver.RoiSettings.prototype.getStopX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flir_boson_driver.RoiSettings} returns this
 */
proto.flir_boson_driver.RoiSettings.prototype.setStopX = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float start_y = 3;
 * @return {number}
 */
proto.flir_boson_driver.RoiSettings.prototype.getStartY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flir_boson_driver.RoiSettings} returns this
 */
proto.flir_boson_driver.RoiSettings.prototype.setStartY = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float stop_y = 4;
 * @return {number}
 */
proto.flir_boson_driver.RoiSettings.prototype.getStopY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.flir_boson_driver.RoiSettings} returns this
 */
proto.flir_boson_driver.RoiSettings.prototype.setStopY = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


goog.object.extend(exports, proto.flir_boson_driver);
